import { Input } from '@/components/ui/input';
import { titleChanged } from '@/providers/AdminEngagementProvider/actions';
import { useAdminEngagementContext } from '@/providers/AdminEngagementProvider/AdminEngagementContext';

export function TitleInput() {
  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state: { editorMode, ...engagement },
    dispatch,
  } = useAdminEngagementContext();

  return (
    <Input
      id="title"
      value={engagement.title}
      onChange={(e) => dispatch(titleChanged({ title: e.target.value }))}
    />
  );
}
